/** When your routing table is too long, you can split it into small modules **/
const activeMenu = '/orderInfo'
const iconName = 'el-icon-s-order'
export default [
  //注文、入荷
  {
    path: activeMenu,
    name: 'orderInfo',
    alwaysShow: true,
    component: () => import('@/layout/Layout'),
    redirect: '/orderInfo/orderInfoOverview',
    meta: {
      order: 400,
      icon: iconName,
      title: 'resource.MENU.ORDER_TITLE'
    },
    //注文
    children: [
      {
        path: 'orderInfoOverview',
        component: () => import('@/views/orderInfo/orderInfo'),
        name: 'orderInfoOverview',
        hidden: false,
        meta: {
          order: 401,
          activeMenu: activeMenu,
          icon: iconName,
          //角色：注文
          permission: ['orderInfo'],
          title: '手配',
        }
      },
      //検査室入荷
      {
        path: 'checkRecefoOverview',
        component: () => import('@/views/checkReceInfo/checkReceBasicInfo'),
        name: 'checkRecefoOverview',
        hidden: false,
        meta: {
          order: 402,
          icon: iconName,
          //角色：検査室入荷
          permission: ['checkRecefoInfo'],
          title: 'resource.MENU.CHECK_RECE_VIEW',
        }
      },
      // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 課題_発送予定機能の追加
      //発送予定
      {
        path: 'prepareTransInfoOverview',
        component: () => import('@/views/prepareTransInfo/prepareTransInfo'),
        name: 'prepareTransInfoOverview',
        hidden: false,
        meta: {
          order: 403,
          icon: iconName,
          //角色：発送予定
          permission: ['prepareTransInfo'],
          title: 'resource.MENU.PREPARE_TRANS_VIEW',
        }
      },
      // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      //運送（船便）
       {
        path: 'transportInfoOverview',
        component: () => import('@/views/transportInfo/transportInfo'),
        name: 'transportInfoOverview',
        hidden: false,
         meta: {
           // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_発送予定機能の追加
          // order: 403,
           order: 404,
           // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          icon: iconName,
          //角色：運送（船便）
          permission: ['transportInfo'],
          title: 'resource.MENU.TRANSPORT_VIEW',
        }
      },
      //日本入荷
      {
        path: 'jpRcvInfoOverview',
        component: () => import('@/views/jpRcvInfo/jpRcvInfo'),
        name: 'jpRcvInfoOverview',
        hidden: false,
        meta: {
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_発送予定機能の追加
          // order: 404,
          order: 405,
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          icon: iconName,
          //角色：日本入荷
          permission: ['jpRcvInfo'],
          title: 'resource.MENU.JP_RCV_VIEW',
        }
      },
      //支払
      {
        path: 'customerPayInfoOverview',
        component: () => import('@/views/customerPayInfo/customerPayInfo'),
        name: 'customerPayInfoOverview',
        hidden: false,
        meta: {
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 課題_発送予定機能の追加
          // order: 405,
          order: 406,
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          icon: iconName,
          //角色：管理者、業務
          permission: ['customerPayInfo'],
          title: 'resource.MENU.CUSTOMER_PAY_VIEW',
        }
      },
    ]
  }
]

